export const VALIDATORS = {
  "channel": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu chọn kênh bán hàng"
    }
  ],
  "channelPayment":[
    {
      errorName: "required",
      errorDescription: "Yêu cầu chọn kênh thanh toán"
    }
  ],
}
